import rootReducer from './state/root-reducer';
import RewardsRoutesHandler from './components/rewards-routes-handler';

const routes = {
  '/rewards/promo/redeem': {
    fullPageComponent: RewardsRoutesHandler,
    authRequired: true,
  },
  '/rewards/partnerships/marriottbonvoy/redirect': {
    fullPageComponent: RewardsRoutesHandler,
    hideGlobalNav: true,
    hideGlobalFooter: true,
  },
  '/rewards': {
    fullPageComponent: RewardsRoutesHandler,
  },
  // To ensure specific routes are matched first, they must be defined before the wildcard route
  '/rewards/*': {
    fullPageComponent: RewardsRoutesHandler,
  },
  '/rewards/partnerships/marriottbonvoy/*': {
    fullPageComponent: RewardsRoutesHandler,
  },
};

export default {
  name: 'rewards',
  reducer: rootReducer,
  routes,
};
